import React from 'react';
import { CountdownBar } from '../components/CountdownBar';
import { Hero } from '../components/Hero';
import { PainPoints } from '../components/PainPoints';
import { Reframe } from '../components/Reframe';
import { InsideCarousel } from '../components/InsideCarousel';
import { ProductIntro } from '../components/ProductIntro';
import { Benefits } from '../components/Benefits';
import { Bonuses } from '../components/Bonuses';
import { Inclusions } from '../components/Inclusions';
import { OfferCard } from '../components/OfferCard';
import { Testimonials } from '../components/Testimonials';
import { Guarantee } from '../components/Guarantee';
import { Faq } from '../components/Faq';
import { PurchaseToast } from '../components/PurchaseToast';
import { Sparkle } from '../components/Sparkle';
type LandingProps = {
  showPurchaseToast: boolean;
};
export function Landing({
  showPurchaseToast
}: LandingProps) {
  return <div className="min-h-screen w-full bg-paper text-ink" data-id="element-184" data-mp="m8dcsh1fil0t">
      <CountdownBar data-id="element-185" data-mp="29samounrz0t" />
      <Hero data-id="element-186" data-mp="2b3bafst4qnp" />
      <main data-id="element-187" data-mp="2atikkgdo5eb">
        <PainPoints data-id="element-188" data-mp="2bboy9wr7zzy" />
        <Reframe data-id="element-189" data-mp="27nv19nedbkp" />
        <InsideCarousel data-id="element-190" data-mp="3tgl7xhmbze02" />
        <ProductIntro data-id="element-191" data-mp="3tfa45hsvy68y" />
        <Benefits data-id="element-192" data-mp="3tes0w17t2rrj" />
        <Bonuses data-id="element-193" data-mp="3tifut1h5xg6s" />
        <Inclusions data-id="element-194" data-mp="3peqa4n3lzir1" />
        <OfferCard id="offer" data-id="element-195" data-mp="3pe85b22vrw7i" />
        <Testimonials data-id="element-196" data-mp="3pf9q3y9p7x2f" />
        <Guarantee data-id="element-197" data-mp="3pgubaxa4i3nm" />
        <OfferCard data-id="element-198" data-mp="3kfn4p1jpvaij" />
        <Faq data-id="element-199" data-mp="3kgexk4lxiu54" />
      </main>
      <footer className="border-t-2 border-ink bg-ink py-8 text-center text-sm text-kraft-light" data-id="element-200" data-mp="3kgydjfs0r8gi">
        <p className="flex items-center justify-center gap-2 font-display font-bold text-cream" data-id="element-201" data-mp="kz8d3hpwm1jv">
          <Sparkle className="h-3 w-3" data-id="element-202" data-mp="h07xe82q3f13" /> Priority Journal <Sparkle className="h-3 w-3" data-id="element-203" data-mp="c87z0k2awu6m" />
        </p>
        <p className="mt-2" data-id="element-204" data-mp="c6n58wnt9f9t">© {new Date().getFullYear()} · Digital PDF product</p>
      </footer>
      {showPurchaseToast && <PurchaseToast data-id="element-205" data-mp="78v4re93oku0" />}
    </div>;
}